// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Purpose-built section styles */
.purpose-built-content {
  padding: 2rem 0;
}

.purpose-built-title {
  font-size: 32px;
  font-weight: 700;
  color: #000;
  margin-bottom: 1.5rem;
  line-height: 1.2;
  font-family: 'Gilroy', sans-serif;
}

.purpose-built-text {
  font-size: 1.1rem;
  color: rgba(116, 116, 116, 1);
  line-height: 1.6;
  font-family: 'Gilroy', sans-serif;
  font-weight: 400;
}

.what-content-row .row {
  margin: 0;
}

.what-content-row .col-lg-6 {
  padding: 2rem;
}

.what-content-row img {
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);
}

/* Responsive adjustments */
@media (max-width: 991px) {
  .purpose-built-title {
    font-size: 2rem;
  }
  
  .purpose-built-text {
    font-size: 1rem;
  }
  
  .what-content-row .col-lg-6 {
    padding: 1rem;
  }
} `, "",{"version":3,"sources":["webpack://./src/components/LandingPage/WhatSection.css"],"names":[],"mappings":"AAAA,iCAAiC;AACjC;EACE,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,qBAAqB;EACrB,gBAAgB;EAChB,iCAAiC;AACnC;;AAEA;EACE,iBAAiB;EACjB,6BAA6B;EAC7B,gBAAgB;EAChB,iCAAiC;EACjC,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,yCAAyC;AAC3C;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;EACf;AACF","sourcesContent":["/* Purpose-built section styles */\n.purpose-built-content {\n  padding: 2rem 0;\n}\n\n.purpose-built-title {\n  font-size: 32px;\n  font-weight: 700;\n  color: #000;\n  margin-bottom: 1.5rem;\n  line-height: 1.2;\n  font-family: 'Gilroy', sans-serif;\n}\n\n.purpose-built-text {\n  font-size: 1.1rem;\n  color: rgba(116, 116, 116, 1);\n  line-height: 1.6;\n  font-family: 'Gilroy', sans-serif;\n  font-weight: 400;\n}\n\n.what-content-row .row {\n  margin: 0;\n}\n\n.what-content-row .col-lg-6 {\n  padding: 2rem;\n}\n\n.what-content-row img {\n  border-radius: 12px;\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.1);\n}\n\n/* Responsive adjustments */\n@media (max-width: 991px) {\n  .purpose-built-title {\n    font-size: 2rem;\n  }\n  \n  .purpose-built-text {\n    font-size: 1rem;\n  }\n  \n  .what-content-row .col-lg-6 {\n    padding: 1rem;\n  }\n} "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
